var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hide"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00523 14.55C7.35531 14.55 5.7483 14.1091 4.22873 13.2393C2.66891 12.3466 1.27085 11.0389 0.0730873 9.3522C-0.0168935 9.24221 -0.026587 9.08219 0.059631 8.96055C1.25932 7.26775 2.66077 5.95564 4.22496 5.06062C5.74482 4.19101 7.35253 3.75 9.00294 3.75C9.00425 3.75 9.00528 3.75 9.00658 3.75C10.6572 3.75065 12.2642 4.19227 13.783 5.06261C15.3449 5.95763 16.7437 7.26918 17.9406 8.96076C17.9792 9.01545 18 9.08065 18 9.14744V9.15256C18 9.21939 17.9792 9.28455 17.9406 9.33924C16.7437 11.0309 15.3451 12.3424 13.7837 13.2374C12.2654 14.1077 10.6589 14.5493 9.00883 14.55C9.00765 14.55 9.00642 14.55 9.00523 14.55ZM0.729742 9.14695C2.96908 12.2144 5.90053 13.9004 9.00523 13.9004C9.00642 13.9004 9.00748 13.9004 9.00863 13.9004C12.111 13.8992 15.0384 12.2142 17.2728 9.15C15.0384 6.08576 12.1102 4.40084 9.00638 4.39962C9.00544 4.39962 9.00397 4.39962 9.00303 4.39962C5.89865 4.39962 2.96867 6.083 0.729742 9.14695Z",
    fill: "#132122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.00004 13.1114C6.81649 13.1114 5.04004 11.335 5.04004 9.15141C5.04004 6.96786 6.81649 5.19141 9.00004 5.19141C11.1836 5.19141 12.96 6.96786 12.96 9.15141C12.96 11.335 11.1835 13.1114 9.00004 13.1114ZM9.00004 5.86905C7.19017 5.86905 5.71769 7.34154 5.71769 9.15141C5.71769 10.9613 7.19017 12.4338 9.00004 12.4338C10.8099 12.4338 12.2824 10.9613 12.2824 9.15141C12.2824 7.34154 10.8099 5.86905 9.00004 5.86905Z",
    fill: "#132122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.5068 9.51156C10.345 9.51156 10.2139 9.38042 10.2139 9.21868C10.2139 8.51214 9.63907 7.93733 8.93253 7.93733C8.77079 7.93733 8.63965 7.80619 8.63965 7.64444C8.63965 7.4827 8.77079 7.35156 8.93253 7.35156C9.96204 7.35156 10.7996 8.18913 10.7996 9.21868C10.7996 9.38042 10.6685 9.51156 10.5068 9.51156Z",
    fill: "#132122"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.0456 13.9165L1.0426 5.2545C0.880937 5.16116 0.825539 4.95441 0.918877 4.79274C1.01221 4.63107 1.21897 4.57568 1.38063 4.66901L16.3836 13.331C16.5453 13.4243 16.6007 13.6311 16.5073 13.7927C16.414 13.9544 16.2072 14.0098 16.0456 13.9165Z",
    fill: "#132122"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideView);
export default __webpack_public_path__ + "static/media/hideView.0e64e255.svg";
export { ForwardRef as ReactComponent };